<template>
    <div class="library-deliverable-table-checkbox-cell">
        <Checkbox :model-value="isSelected" @click.prevent="toggleSelection" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        isSelected: {
            required: true,
            type: Boolean
        }
    },
    emits: ["selectionChanged"],
    methods: {
        toggleSelection() {
            this.$emit("selectionChanged");
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-deliverable-table-checkbox-cell {
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: background 0.2s linear;

    &:hover {
        background: $grey1;
    }

    .ivu-checkbox-wrapper {
        align-items: center;
        bottom: 0;
        display: flex;
        justify-content: center;
        left: 0;
        margin: 0;
        position: absolute;
        right: 0;
        top: 0;
    }
}
</style>
